import { useContext } from 'react';
import { Container as InversifyContainer } from '@dealroadshow/jsbro/DI';
import { bindingScopeValues } from 'inversify';

class Container extends InversifyContainer {
  constructor() {
    super({
      autobind: true,
      defaultScope: bindingScopeValues.Singleton,
    });

    this.bind(Container).toConstantValue(this);
  }

  public bindValue(key: any, value: any) {
    return this.bind(key).toConstantValue(value);
  }

  // skipCheck gives the ability to have nested context providers
  // Current implementation of OTelTraceContextProvider uses this feature. It may be removed in the future.
  public bindContextValue(key: any, value: any, skipCheck = false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (!skipCheck && useContext(key)) {
      throw new Error(`
      It looks like you are trying to render more than one instance of global context.
      We desire all contexts that are synchronised to DI Container as global. Please make sure that Bootstrap is the
      only place where you render your global contexts.
      `);
    }

    if (this.isCurrentBound(key)) {
      this.unbind(key);
    }

    return this.bindValue(key, value);
  }
}

export default Container;
